import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import * as environment from "../modules/environment";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Selector from 'react-year-month-selector';
import * as TextManager from "../modules/languages/TextManager";
import * as http from "../modules/http";
import moment from "moment/moment";
import Alert from './Alert';
import {fetchCustomeraDataIfNeeded} from '../redux/actions/CustomersActions';
import {fetchProvidersDataIfNeeded} from "../redux/actions/ProvidersActions";


const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];


const headersForUpload = ['מספר חנות', 'מספר לקוח', 'שם לקוח', 'מספר תז', 'כתובת', 'ספק', 'מספר קוים', 'מספר מנוי', 'שם משווק/הערות',
    '', '', '', 'סלולר', 'טלויזיה', 'אינטרנט'];

const spareToProvidersFromStoreId = ['','','','','','','','','','','','',''];

class ModalComponent extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            year: 2021,
            month: 0,
            dateForRequest: '2021-01-01',
            warning: '',
            errorInUploadFile: false,
            errorText: ''
        };

        this.fileUpload = React.createRef();
        this.fromButton = false;
    }

    componentDidMount() {
        this.props.dispatch(fetchProvidersDataIfNeeded());
    }

    toggle = () => {
        if(this.fromButton) {
            this.fromButton = false;
        }
        else {
            this.setState({
                modal: !this.state.modal
            });
        }
    };

    setMonth = (year, month) => {
        //let tmp = monthNames[month] + ", " + year;
        this.setState({year: year, month: month});

        let fixMonth = month + 1;

        let dateStr = year + (fixMonth < 10 ? '0' + fixMonth : String(fixMonth)) + '01';

        let dateForRequest = moment(dateStr).format('YYYY-MM-DD');

        this.setState({dateForRequest: dateForRequest});
    };

    showFileUpload = (e) => {
        e.preventDefault();
        this.fromButton = true;
        this.fileUpload.current.click();
    };

    handleUploadFile = (e) => {

        let file = e.target.files[0];
        let formData = new FormData();
        formData.append('file', file);

        e.target.value = null;

        http.postToServer(
            'customers/upload_customers?isCheck=true&month='+this.state.dateForRequest+'&storeId='+this.props.userData.data.id,
            formData,
            (response) => {
                //console.log('Bingo ' + response.data);
                this.setState({isFileReadyToUpload: true, dataToUpload: formData})
            },
            (response) => {
                //console.log('error CSV ' + response.data.message);
                this.setState({errorInUploadFile: true, errorText: response.data.message})
            }
        );
    };

    saveDocs = () => {

        http.postToServer(
            'customers/upload_customers?isCheck=false&month='+this.state.dateForRequest+'&storeId='+this.props.userData.data.id,
            this.state.dataToUpload,
            (response) => {
                //console.log('Bingo ' + response.data);
                this.setState({isFileReadyToUpload: false, dataToUpload: '', errorInUploadFile: false, errorText: ''});
                this.props.dispatch(fetchCustomeraDataIfNeeded(this.props.queryParam));
                this.toggle();
            },
            (response) => {
                //console.log('error CSV ' + response.data.message);
                this.setState({errorInUploadFile: true, errorText: response.data.message})
            }
        );
    };

    downloadForm = () => {
        let providersCellular   = this.props.providers.filter(e => e.providerType === 1);
        let providersTV         = this.props.providers.filter(e => e.providerType === 2);
        let providersInternet   = this.props.providers.filter(e => e.providerType === 3);

        //console.log(providersCellular);

        var result = ',,,,' + 'חברים שימו לב.. לכתוב בעמודת ספק את שם המוצר בדיוק כפי שרשום לך בטבלה הזו' + '\n';

        result += headersForUpload.join(',') + '\n';

        result += this.props.userData.data.id + spareToProvidersFromStoreId;

        if(providersCellular.length > 0) {
            result += providersCellular[0].name + ',';
        }
        else {
            result += ',';
        }

        if(providersTV.length > 0) {
            result += providersTV[0].name + ',';
        }
        else {
            result += ',';
        }

        if(providersInternet.length > 0) {
            result += providersInternet[0].name + ',';
        }
        else {
            result += ',';
        }

        result += '\n';

        let maxLength = providersCellular.length;
        if(providersTV.length > maxLength) maxLength = providersTV.length;
        if(providersInternet.length > maxLength) maxLength = providersInternet.length;

        for(let i = 1; i < maxLength; i++) {
            result += spareToProvidersFromStoreId;

            if(i < providersCellular.length) {
                result += providersCellular[i].name + ',';
            }

            if(i < providersTV.length) {
                result += providersTV[i].name + ',';
            }

            if(i < providersInternet.length) {
                result += providersInternet[i].name + ',';
            }

            result += '\n';
        }


        let link = window.document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(result));
        link.setAttribute("download", "downloadForm.csv");
        link.click();
    };

    render() {
        let Icon;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }



        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '700px', width: '700px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    {(this.state.errorInUploadFile) &&
                    <Row>
                        <Alert color='danger' className='alert--bordered' icon>
                            <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                            <p>{this.state.errorText}</p>
                        </Alert>
                    </Row>}
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            <Row>
                                <Col md={4}>
                                    <ButtonToolbar>
                                        <input type="file" id="exampleFile"
                                               style={{display: 'none', marginLeft: '5px'}}
                                               ref={this.fileUpload}
                                               accept='.csv'
                                               onChange={e => this.handleUploadFile(e)}/>
                                        <Button outline color='primary' size='sm'
                                                style={{marginTop: "40px", marginLeft: '50px'}}
                                                onClick={(e) => this.showFileUpload(e)}>Upload</Button>
                                        <Button outline color='primary' size='sm'
                                                style={{marginTop: "50px", marginLeft: '30px'}}
                                                onClick={(e) => this.downloadForm(e)}>Download Form</Button>
                                    </ButtonToolbar>
                                </Col>
                                <Col md={8}>
                                    <div className='date-picker date-picker--interval' style={{padding: 0}}>
                                        <Selector
                                            key='from'
                                            year={this.state.year}
                                            month={this.state.month}
                                            open={true}
                                            onChange={(year, month) => this.setMonth(year, month)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    {this.state.isFileReadyToUpload && <Alert color='success' className='success--bordered' icon>
                        <p>Document looks good. You can upload it</p>
                    </Alert>}
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>Cancel</Button>{' '}
                        {this.state.isFileReadyToUpload && <Button outline={this.props.colored} color={this.props.color}
                                onClick={() => this.saveDocs()}>Save</Button>}
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData,
        providers: state.providers.data
    };
};

export default withRouter(connect(mapStateToProps)(ModalComponent))